import React, { useState, useEffect } from 'react';
import { Button, Typography, Space } from 'antd';
import { CheckSquareOutlined, UnorderedListOutlined, TrophyOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import MyTasks from '../my-tasks/MyTasks';
import MyCompletions from '../my-completions/MyCompletions';
import MyRewards from '../my-rewards/MyRewards';
import '../../order/orders/Orders.css';
import './MyWorkPage.css';

const { Title } = Typography;

const VIEW_KEYS = { tasks: 'tasks', completions: 'completions', rewards: 'rewards' };

export default function MyWorkPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const viewFromUrl = searchParams.get('tab');
  const initialView =
    viewFromUrl && Object.values(VIEW_KEYS).includes(viewFromUrl) ? viewFromUrl : VIEW_KEYS.tasks;
  const [activeView, setActiveView] = useState(initialView);

  useEffect(() => {
    const t = searchParams.get('tab');
    if (t && Object.values(VIEW_KEYS).includes(t)) setActiveView(t);
  }, [searchParams]);

  const setView = (key) => {
    setActiveView(key);
    setSearchParams({ tab: key });
  };

  return (
    <div className="my-work-page">
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div className="orders-header">
          <div className="orders-header-title-row">
            <Title level={3} style={{ margin: 0 }}>
              My Work
            </Title>
            <div className="orders-header-actions">
              <Button
                type={activeView === VIEW_KEYS.tasks ? 'primary' : 'default'}
                icon={<CheckSquareOutlined />}
                onClick={() => setView(VIEW_KEYS.tasks)}
                className={activeView === VIEW_KEYS.tasks ? 'orders-add-btn app-btn-primary' : 'orders-add-btn'}
              >
                My Tasks
              </Button>
              <Button
                type={activeView === VIEW_KEYS.completions ? 'primary' : 'default'}
                icon={<UnorderedListOutlined />}
                onClick={() => setView(VIEW_KEYS.completions)}
                className={activeView === VIEW_KEYS.completions ? 'orders-add-btn app-btn-primary' : 'orders-add-btn'}
              >
                My completions
              </Button>
              <Button
                type={activeView === VIEW_KEYS.rewards ? 'primary' : 'default'}
                icon={<TrophyOutlined />}
                onClick={() => setView(VIEW_KEYS.rewards)}
                className={activeView === VIEW_KEYS.rewards ? 'orders-add-btn app-btn-primary' : 'orders-add-btn'}
              >
                My rewards
              </Button>
            </div>
          </div>
        </div>
        {activeView === VIEW_KEYS.tasks && <MyTasks embedded />}
        {activeView === VIEW_KEYS.completions && <MyCompletions embedded />}
        {activeView === VIEW_KEYS.rewards && <MyRewards embedded />}
      </Space>
    </div>
  );
}
